import { Link } from 'react-router-dom';
import { useCart } from '../Cart/CartContext';
import { useState, useEffect } from 'react';

export default function ProductCard({ product }) {
  const { cart, addToCart } = useCart();
  const isInCart = cart.some(item => item.id === product.id);

  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    setIsMobile(checkMobile);
  }, []);

  const handleEnter = () => !isMobile && setIsHovered(true);
  const handleLeave = () => !isMobile && setIsHovered(false);
  const handleTap = () => isMobile && setIsHovered(prev => !prev);

  return (
    <div
      className={`product-card ${isInCart ? 'is-in-cart' : ''}`}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      onClick={handleTap}
    >
      {isHovered && product.videoDemo ? (
        <video
          className="product-card-preview"
          src={product.videoDemo}
          autoPlay
          muted
          loop
          playsInline
        />
      ) : (
        <img
          className="card-preview"
          src={product.imageUrl}
          alt={product.UITitle}
        />
      )}

      <h3>{product.UITitle}</h3>
      <p>{product.description}</p>
      <p><strong>${product.price.toFixed(2)}</strong></p>

      {isInCart && (
        <div className="in-cart-productBadge">In Cart</div>
      )}

      <div>
        <Link to={`/product/${product.id}`}>
          <button>View Details</button>
        </Link>
        <button
          onClick={() => addToCart(product)}
          disabled={isInCart}
        >
          {isInCart ? "Added" : "Add to Cart"}
        </button>
      </div>
    </div>
  );
}
